import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetResponseCode,
  notificationStore,
  parseNumberByPrecision,
  userInfoStore,
} from '@pascal/pascal-core';
import { inputValidationStore, manualBetStore } from '../../../../store';
import { betSectionBoxesText } from '../../../../enums/betSectionBoxesText';
import { handlePlusMinusValue, useAmountValidation } from '../../../../helpers';
import { BetAmountSection } from '../../../../components/common/bettingPart';

import { GameResponseTypeName } from '../../../../enums';

export const BetAmountSectionWr = observer(
  ({ limits, betAmount, index, inputDisable, handleOpenNumPad, activeFreeBet, t }) => {
    const { balance } = userInfoStore;
    const limitParams = {
      storeValue: betAmount,
      minValue: limits.minBet,
      maxValue: limits.maxBet,
      incDec: limits.minBet,
    };
    // sendStakeUpdate(betAmount);
    const stopHandle = inputValidationStore.validationSections[index].isClosedDoBet;

    const handleAddOrMinusBetAmount = (actionType, index) => {
      if (!stopHandle) {
        const changedBetAmount = handlePlusMinusValue(actionType, limitParams);
        manualBetStore.setBetAmount(changedBetAmount, index);
      }
    };

    const handleChangeBetAmount = (index, number, actionType) => {
      let changedBetAmount;
      if (betAmount) {
        if (actionType) {
          if (actionType === betSectionBoxesText.split) {
            if (betAmount * number >= limits.minBet) {
              changedBetAmount = betAmount * number;
            } else {
              notificationStore.setNotificationType({
                responseCode: BetResponseCode.InValidMinBet,
              });
              changedBetAmount = limits.minBet;
            }
          } else if (actionType === betSectionBoxesText.allIn) {
            changedBetAmount =
              balance > limits.maxBet
                ? limits.maxBet
                : balance < limits.minBet
                ? limits.minBet
                : balance;
            if (balance < limits.minBet) {
              notificationStore.setNotificationType({
                responseCode: BetResponseCode.InValidMinBet,
              });
            } else if (balance > limits.maxBet) {
              notificationStore.setNotificationType({
                responseCode: BetResponseCode.InValidMaxBet,
              });
            }
          } else if (actionType === betSectionBoxesText.max) {
            changedBetAmount = limits.maxBet;
          } else {
            changedBetAmount = limits.minBet;
          }
        } else if (betAmount * number <= limits.maxBet) {
          if (betAmount * number >= limits.minBet) {
            changedBetAmount = betAmount * number;
          } else {
            changedBetAmount = limits.minBet;
          }
        } else {
          notificationStore.setNotificationType({
            responseCode: BetResponseCode.InValidMaxBet,
          });
          changedBetAmount = limits.maxBet;
        }
        manualBetStore.setBetAmount(parseNumberByPrecision(1, changedBetAmount), index);
      } else {
        manualBetStore.setBetAmount(parseNumberByPrecision(1, limits.minBet), index);
      }
    };

    const handleResetBetAmountSection = useCallback((index) => {
      manualBetStore.resetBetSectionData(index);
    }, []);

    const removeSection = useCallback((index) => {
      manualBetStore.removeBetSection(index);
    }, []);

    const onChangeEvent = useCallback(({ changeValue, propName }) => {
      manualBetStore.setBetAmount(changeValue, propName);
    }, []);

    const onBlur = (e) => {
      inputValidationStore.setDefaultValue(
        e.target?.value.trim(),
        manualBetStore.setBetAmount,
        limitParams,
        index,
        GameResponseTypeName.Bet
      );
    };

    const { onChange: handleChangeAmount } = useAmountValidation(onChangeEvent, limits);

    return (
      <BetAmountSection
        limits={limits}
        betAmount={betAmount}
        index={index}
        t={t}
        balance={balance}
        isDoubleSectionsOpen={manualBetStore.isDoubleSectionsOpen}
        handleAddOrMinusBetAmount={handleAddOrMinusBetAmount}
        handleChangeBetAmount={handleChangeBetAmount}
        handleResetBetAmountSection={handleResetBetAmountSection}
        removeSection={removeSection}
        limitParams={limitParams}
        onChangeEvent={onChangeEvent}
        handleChangeAmount={handleChangeAmount}
        onBlur={onBlur}
        inputDisable={inputDisable}
        handleOpenNumPad={handleOpenNumPad}
        activeFreeBet={activeFreeBet}
      />
    );
  }
);
